import { render, staticRenderFns } from "./AdditionalInformationChangesLog.vue?vue&type=template&id=d674ebe4&scoped=true"
import script from "./AdditionalInformationChangesLog.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationChangesLog.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformationChangesLog.vue?vue&type=style&index=0&id=d674ebe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d674ebe4",
  null
  
)

export default component.exports